import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { BeneficioClientesVulnerablesCovid19Component } from './beneficio-clientes-vulnerables-covid19/beneficio-clientes-vulnerables-covid19.component';
import { NegociacionComunidadesComercioComponent } from './negociacion-comunidades-comercio/negociacion-comunidades-comercio.component';
import { RestriccionDeConveniosComponent } from './restriccion-de-convenios/restriccion-de-convenios.component';
import { ModificacionDatosComercialesComponent } from './modificacion-datos-comerciales/modificacion-datos-comerciales.component';
import { CorrecionPagoPorErrorComponent } from './correcion-pago-por-error/correcion-pago-por-error.component';
import { PagoDobleComponent } from './pago-doble/pago-doble.component';
import { TrasladoMetroBolsaComponent } from './traslado-metro-bolsa/traslado-metro-bolsa.component';
import { NegociacionDeudaClientesResidencialesComponent } from './negociacion-deuda-clientes-residenciales/negociacion-deuda-clientes-residenciales.component';
import { SuscripcionBoletaElectronicaComponent } from './suscripcion-boleta-electronica/suscripcion-boleta-electronica.component';
import { DuplicadoBoletaComponent } from './duplicado-boleta/duplicado-boleta.component';
import { PagaTuCuentaComponent } from './paga-tu-cuenta/paga-tu-cuenta.component';
import { BeneficioCovid19Component } from './beneficio-covid19/beneficio-covid19.component';
import { ConoceCentroAyudaComponent } from './conoce-centro-ayuda/conoce-centro-ayuda.component';
import { ConoceBoletaElectronicaComponent } from './conoce-tu-boleta/conoce-tu-boleta.component';
import { AgendamientoHoraComponent } from './agendamiento-hora/agendamiento-hora.component';
import { ExitoAgendamientoComponent } from './agendamiento-hora/exito-agendamiento/exito-agendamiento.component';
import { VentaReguladoresComponent } from './venta-reguladores/venta-reguladores.component';
import { AsistenteVirtualComponent } from './asistente-virtual/asistente-virtual.component';
import { NegociacionComerciosComponent } from './negociacion-comercios/negociacion-comercios.component';
import { CambioNombreBoletaComponent } from './cambio-nombre-boleta/cambio-nombre-boleta.component';
import { ContactenosComponent } from './contactenos/contactenos.component';
import { TrackingComponent } from './tracking/tracking.component';
import { InfoCuentaComponent } from './info-cuenta/info-cuenta.component';


const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'beneficio-clientes-vulnerables-covid19', component: BeneficioClientesVulnerablesCovid19Component },

  { path: 'info-cuenta', component: InfoCuentaComponent },

  //{ path: 'agendamiento-de-hora', component: AgendamientoHoraComponent },
  //{ path: 'exito-agendamiento-de-hora', component: ExitoAgendamientoComponent },
  { path: 'negociacion-comercios', component: NegociacionComerciosComponent },
  { path: 'negociacion-comunidades', component: NegociacionComunidadesComercioComponent },
  { path: 'restriccion-de-convenios', component:  RestriccionDeConveniosComponent},
  { path: 'modificacion-datos-comerciales', component:  ModificacionDatosComercialesComponent},
  { path: 'correcion-pago-por-error', component:  CorrecionPagoPorErrorComponent},
  { path: 'pago-doble', component:  PagoDobleComponent},
  { path: 'traslado-metro-bolsa', component:  TrasladoMetroBolsaComponent},
  { path: 'negociacion-deuda-clientes-residenciales', component:  NegociacionDeudaClientesResidencialesComponent},
  { path: 'suscripcion-boleta-electronica', component:  SuscripcionBoletaElectronicaComponent},
  { path: 'duplicado-boleta', component:  DuplicadoBoletaComponent},
  { path: 'paga-tu-cuenta', component:  PagaTuCuentaComponent},
  { path: 'beneficio-covid19', component:  BeneficioCovid19Component},
  { path: 'conoce-tu-boleta', component:  ConoceBoletaElectronicaComponent},
  { path: 'conoce-centro-ayuda', component:  ConoceCentroAyudaComponent},
  { path: 'venta-reguladores', component:  VentaReguladoresComponent},
  { path: 'asistente-virtual', component:  AsistenteVirtualComponent},
  { path: 'cambio-nombre-boleta', component:  CambioNombreBoletaComponent},
  { path: 'contactenos', component: ContactenosComponent},
  { path: 'tracking', component: TrackingComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
